import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff, deduplicateRequest } from '../common';
import { NAMESPACES } from '../configuration';

const BASE_URL = NAMESPACES.configuration_api.pedidos_type;

// Helper function to configure the Axios instance
const api: AxiosInstance = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Wrap with cache - using longer TTL since pedidos types rarely change
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'configuration_api',
  group: 'pedidos_type',
  defaultTtl: '30m', // 30 minutes cache since this data rarely changes
  hashLargeSegments: true,
  emitMeta: true,
});

// Types
export interface PedidoType {
  pedido_type_id: number;
  pedido_type_name: string;
  description?: string;
  is_active?: boolean;
}

// Function to fetch all pedidos types (cached)
export const getAllPedidosType = async (): Promise<AxiosResponse<PedidoType[]>> => {
  return await deduplicateRequest(
    'getAllPedidosType',
    () => retryWithBackoff(() => 
      cachedApi.get<PedidoType[]>('/GetAllPedidosType', undefined, { ttl: '30m' })
    )
  );
};

// Clear cache when needed (e.g., after admin updates)
export const clearPedidosTypeCache = async (): Promise<void> => {
  await cachedApi.clear();
};